import { signInUser } from '@/services/api/auth';
import { useAuthStore } from '@/store/auth';
import { SignInPayload, SignInResponse } from '@/types/api/auth';
import { ApiErrorResponse } from '@/types/api/common';
import { useMutation } from '@tanstack/react-query';

export const useSignIn = () => {
  const setToken = useAuthStore((state) => state.setToken);
  const setUser = useAuthStore((state) => state.setUser);
  const setStorageType = useAuthStore((state) => state.setStorageType);
  const setRefreshToken = useAuthStore((state) => state.setRefreshToken);
  return useMutation<SignInResponse, ApiErrorResponse, SignInPayload>({
    mutationFn: (payload) => signInUser(payload),
    onSuccess: ({ data }) => {
      setStorageType('local');
      setToken(data.accessToken);
      if (data.refreshToken) setRefreshToken(data.refreshToken);
      setUser({
        id: data.id,
        email: data.email,
        isVerified: data.isVerified,
        status: data.status,
        tenantId: data.tenantId,
        fullName: data.fullName,
        userName: data.userName,
        areaOfInterest: data.areaOfInterest,
        profilePicture: data.profilePicture,
      });
    },
  });
};
